import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import tenantService from '../../services/tenantService';

// Async thunk for fetching tenant info
export const fetchTenantInfo = createAsyncThunk(
  'tenant/fetchTenantInfo',
  async (_, { rejectWithValue }) => {
    try {
      const response = await tenantService.getTenantInfo(); // Update with your actual API endpoint
    //   console.log("response",response);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateTenantInfo = createAsyncThunk(
  'tenant/updateTenantInfo',
  async (data, { rejectWithValue }) => {
    try {
      const response = await tenantService.updateTenantInfo(data);
    //   console.log("updtetenantdata",response)
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


const tenantSlice = createSlice({
  name: 'tenant',
  initialState: {
    data: null,
    loading: false,
    error: null,
    success: false,
    updating: false
  },
  reducers: {
    clearTenantInfo: (state) => {
      state.data = null;
      state.error = null;
      state.success = false;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch tenant info
      .addCase(fetchTenantInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTenantInfo.fulfilled, (state, action) => {
            state.loading = false;
            // If the API returns 200 OK but success is false
            if (action.payload.success === false) {
                state.error = action.payload.error; // This is the string "Internal Server Error"
                state.data = null;
            } else {
                state.data = action.payload.data;
                state.success = true;
                state.error = null;
            }
            })
            .addCase(fetchTenantInfo.rejected, (state, action) => {
            state.loading = false;
            // action.payload is now the string from rejectWithValue
            state.error = action.payload; 
            state.success = false;
        })
      // Update tenant info
      .addCase(updateTenantInfo.pending, (state) => {
        state.updating = true;
        state.error = null;
      })
      .addCase(updateTenantInfo.fulfilled, (state, action) => {
        state.updating = false;
        state.data = action.payload.data;
        state.success = action.payload.success;
      })
      .addCase(updateTenantInfo.rejected, (state, action) => {
        state.updating = false;
        state.error = action.payload;
      });
  }
});

export const { clearTenantInfo } = tenantSlice.actions;
export default tenantSlice.reducer;